export const THREE_SECONDS_IN_MS = 3000;
